/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CalendarBasedStrategyConfig } from './CalendarBasedStrategyConfig';
import {
    instanceOfCalendarBasedStrategyConfig,
    CalendarBasedStrategyConfigFromJSON,
    CalendarBasedStrategyConfigFromJSONTyped,
    CalendarBasedStrategyConfigToJSON,
} from './CalendarBasedStrategyConfig';
import type { ConfigurationBasedStrategyConfig } from './ConfigurationBasedStrategyConfig';
import {
    instanceOfConfigurationBasedStrategyConfig,
    ConfigurationBasedStrategyConfigFromJSON,
    ConfigurationBasedStrategyConfigFromJSONTyped,
    ConfigurationBasedStrategyConfigToJSON,
} from './ConfigurationBasedStrategyConfig';

/**
 * @type UpdateMeetingRequestStrategy
 * The new strategy configuration
 * @export
 */
export type UpdateMeetingRequestStrategy = CalendarBasedStrategyConfig | ConfigurationBasedStrategyConfig;

export function UpdateMeetingRequestStrategyFromJSON(json: any): UpdateMeetingRequestStrategy {
    return UpdateMeetingRequestStrategyFromJSONTyped(json, false);
}

export function UpdateMeetingRequestStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMeetingRequestStrategy {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfCalendarBasedStrategyConfig(json)) {
        return CalendarBasedStrategyConfigFromJSONTyped(json, true);
    }
    if (instanceOfConfigurationBasedStrategyConfig(json)) {
        return ConfigurationBasedStrategyConfigFromJSONTyped(json, true);
    }
    return {} as any;
}

export function UpdateMeetingRequestStrategyToJSON(json: any): any {
    return UpdateMeetingRequestStrategyToJSONTyped(json, false);
}

export function UpdateMeetingRequestStrategyToJSONTyped(value?: UpdateMeetingRequestStrategy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfCalendarBasedStrategyConfig(value)) {
        return CalendarBasedStrategyConfigToJSON(value as CalendarBasedStrategyConfig);
    }
    if (instanceOfConfigurationBasedStrategyConfig(value)) {
        return ConfigurationBasedStrategyConfigToJSON(value as ConfigurationBasedStrategyConfig);
    }
    return {};
}

